import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { tokens } from '../styles/tokens'

const useStyles: any = makeStyles(theme => ({
  blue: {
    background: `linear-gradient(135deg, ${tokens.color.primary[800]}, ${tokens.color.primary[600]})`,
  },
  blue2: {
    backgroundColor: theme.palette.primary.light,
  },
  orange: {
    background: `linear-gradient(135deg, ${tokens.color.error[700]}, ${tokens.color.error[500]})`,
  },
  orange2: {
    backgroundColor: theme.palette.warning.main,
  },
}))

export const useInputDialogColor = () => {
  const classes = useStyles()

  return (orderDirection: string, isNotInfoClient: boolean) => {
    if (orderDirection === 'OD_SELL') {
      return isNotInfoClient ? classes.orange2 : classes.orange
    }
    return isNotInfoClient ? classes.blue2 : classes.blue
  }
}
